import { useConversationsContext } from 'pages/Conversations/context/ConversationsContext';
import React from 'react';
import ChannelListToolbar from '../ChannelList/ChannelListToolbar';
import { TeletriageConversationCenterToolbar } from '../TeletriageConversationCenter/components/TeletriageConversationCenterToolbar';

type TopToolbarProps = {
  shouldShowTeletriageConversationCenter: boolean;
};

const TopToolbar = ({ shouldShowTeletriageConversationCenter }: TopToolbarProps): JSX.Element => {
  const { isTeletriageConversationCenterOpen } = useConversationsContext();

  return shouldShowTeletriageConversationCenter && isTeletriageConversationCenterOpen ? (
    <TeletriageConversationCenterToolbar />
  ) : (
    <ChannelListToolbar />
  );
};

export default TopToolbar;
